//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IVerdragsbijdrageClient {
    /**
     * @return OK
     */
    actieveJaren(): Promise<number[]>;
    /**
     * @param jaar (optional) 
     * @return OK
     */
    woonlanden(jaar?: number | undefined): Promise<string[]>;
    /**
     * @param body (optional) 
     * @return OK
     */
    bereken(body?: VerdragsbijdrageInputModel | undefined): Promise<VerdragsbijdrageOutputModel>;
    /**
     * @param body (optional) 
     * @return OK
     */
    export(body?: VerdragsbijdrageInputModel | undefined): Promise<FileResponse>;
}

export class VerdragsbijdrageClient implements IVerdragsbijdrageClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * @return OK
     */
    actieveJaren( cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/api/v1/Verdragsbijdrage/actieve-jaren";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActieveJaren(_response);
        });
    }

    protected processActieveJaren(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * @param jaar (optional) 
     * @return OK
     */
    woonlanden(jaar?: number | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/Verdragsbijdrage/woonlanden?";
        if (jaar === null)
            throw new Error("The parameter 'jaar' cannot be null.");
        else if (jaar !== undefined)
            url_ += "jaar=" + encodeURIComponent("" + jaar) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWoonlanden(_response);
        });
    }

    protected processWoonlanden(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bereken(body?: VerdragsbijdrageInputModel | undefined, cancelToken?: CancelToken): Promise<VerdragsbijdrageOutputModel> {
        let url_ = this.baseUrl + "/api/v1/Verdragsbijdrage/bereken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBereken(_response);
        });
    }

    protected processBereken(response: AxiosResponse): Promise<VerdragsbijdrageOutputModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VerdragsbijdrageOutputModel.fromJS(resultData200);
            return Promise.resolve<VerdragsbijdrageOutputModel>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VerdragsbijdrageOutputModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    export(body?: VerdragsbijdrageInputModel | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/Verdragsbijdrage/export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExport(_response);
        });
    }

    protected processExport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class OverigInkomenModel implements IOverigInkomenModel {
    ingangsDatum?: Date | null;
    bedrag?: number;

    constructor(data?: IOverigInkomenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingangsDatum = _data["ingangsDatum"] ? new Date(_data["ingangsDatum"].toString()) : <any>null;
            this.bedrag = _data["bedrag"] !== undefined ? _data["bedrag"] : <any>null;
        }
    }

    static fromJS(data: any): OverigInkomenModel {
        data = typeof data === 'object' ? data : {};
        let result = new OverigInkomenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingangsDatum"] = this.ingangsDatum ? this.ingangsDatum.toISOString() : <any>null;
        data["bedrag"] = this.bedrag !== undefined ? this.bedrag : <any>null;
        return data;
    }
}

export interface IOverigInkomenModel {
    ingangsDatum?: Date | null;
    bedrag?: number;
}

export class OverigeVerzekerdenModel implements IOverigeVerzekerdenModel {
    geboorteDatumPartner?: Date | null;
    ingangsDatumPartner?: Date | null;
    ingangsDatumGezinslid1?: Date | null;
    ingangsDatumGezinslid2?: Date | null;
    ingangsDatumGezinslid3?: Date | null;
    ingangsDatumGezinslid4?: Date | null;

    constructor(data?: IOverigeVerzekerdenModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geboorteDatumPartner = _data["geboorteDatumPartner"] ? new Date(_data["geboorteDatumPartner"].toString()) : <any>null;
            this.ingangsDatumPartner = _data["ingangsDatumPartner"] ? new Date(_data["ingangsDatumPartner"].toString()) : <any>null;
            this.ingangsDatumGezinslid1 = _data["ingangsDatumGezinslid1"] ? new Date(_data["ingangsDatumGezinslid1"].toString()) : <any>null;
            this.ingangsDatumGezinslid2 = _data["ingangsDatumGezinslid2"] ? new Date(_data["ingangsDatumGezinslid2"].toString()) : <any>null;
            this.ingangsDatumGezinslid3 = _data["ingangsDatumGezinslid3"] ? new Date(_data["ingangsDatumGezinslid3"].toString()) : <any>null;
            this.ingangsDatumGezinslid4 = _data["ingangsDatumGezinslid4"] ? new Date(_data["ingangsDatumGezinslid4"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): OverigeVerzekerdenModel {
        data = typeof data === 'object' ? data : {};
        let result = new OverigeVerzekerdenModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geboorteDatumPartner"] = this.geboorteDatumPartner ? this.geboorteDatumPartner.toISOString() : <any>null;
        data["ingangsDatumPartner"] = this.ingangsDatumPartner ? this.ingangsDatumPartner.toISOString() : <any>null;
        data["ingangsDatumGezinslid1"] = this.ingangsDatumGezinslid1 ? this.ingangsDatumGezinslid1.toISOString() : <any>null;
        data["ingangsDatumGezinslid2"] = this.ingangsDatumGezinslid2 ? this.ingangsDatumGezinslid2.toISOString() : <any>null;
        data["ingangsDatumGezinslid3"] = this.ingangsDatumGezinslid3 ? this.ingangsDatumGezinslid3.toISOString() : <any>null;
        data["ingangsDatumGezinslid4"] = this.ingangsDatumGezinslid4 ? this.ingangsDatumGezinslid4.toISOString() : <any>null;
        return data;
    }
}

export interface IOverigeVerzekerdenModel {
    geboorteDatumPartner?: Date | null;
    ingangsDatumPartner?: Date | null;
    ingangsDatumGezinslid1?: Date | null;
    ingangsDatumGezinslid2?: Date | null;
    ingangsDatumGezinslid3?: Date | null;
    ingangsDatumGezinslid4?: Date | null;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class ValidationProblemDetails implements IValidationProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors?: { [key: string]: string[]; } | null;

    [key: string]: any;

    constructor(data?: IValidationProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
            else {
                this.errors = <any>null;
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = this.errors[key] !== undefined ? this.errors[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IValidationProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors?: { [key: string]: string[]; } | null;

    [key: string]: any;
}

export class VerdragsbijdrageInputModel implements IVerdragsbijdrageInputModel {
    alleenstaandeKorting?: boolean;
    geboorteDatumVerzekerde?: Date;
    ingangsDatum?: Date;
    nietVerdienendePartnerKorting?: boolean;
    ouderenKorting?: boolean;
    woonland?: string | null;
    overigInkomen?: OverigInkomenModel | null;
    overigeVerzekerden?: OverigeVerzekerdenModel | null;
    wettelijkPensioenOfUitkering?: WettelijkPensioenOfUitkeringModel | null;

    constructor(data?: IVerdragsbijdrageInputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.overigInkomen = data.overigInkomen && !(<any>data.overigInkomen).toJSON ? new OverigInkomenModel(data.overigInkomen) : <OverigInkomenModel>this.overigInkomen;
            this.overigeVerzekerden = data.overigeVerzekerden && !(<any>data.overigeVerzekerden).toJSON ? new OverigeVerzekerdenModel(data.overigeVerzekerden) : <OverigeVerzekerdenModel>this.overigeVerzekerden;
            this.wettelijkPensioenOfUitkering = data.wettelijkPensioenOfUitkering && !(<any>data.wettelijkPensioenOfUitkering).toJSON ? new WettelijkPensioenOfUitkeringModel(data.wettelijkPensioenOfUitkering) : <WettelijkPensioenOfUitkeringModel>this.wettelijkPensioenOfUitkering;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alleenstaandeKorting = _data["alleenstaandeKorting"] !== undefined ? _data["alleenstaandeKorting"] : <any>null;
            this.geboorteDatumVerzekerde = _data["geboorteDatumVerzekerde"] ? new Date(_data["geboorteDatumVerzekerde"].toString()) : <any>null;
            this.ingangsDatum = _data["ingangsDatum"] ? new Date(_data["ingangsDatum"].toString()) : <any>null;
            this.nietVerdienendePartnerKorting = _data["nietVerdienendePartnerKorting"] !== undefined ? _data["nietVerdienendePartnerKorting"] : <any>null;
            this.ouderenKorting = _data["ouderenKorting"] !== undefined ? _data["ouderenKorting"] : <any>null;
            this.woonland = _data["woonland"] !== undefined ? _data["woonland"] : <any>null;
            this.overigInkomen = _data["overigInkomen"] ? OverigInkomenModel.fromJS(_data["overigInkomen"]) : <any>null;
            this.overigeVerzekerden = _data["overigeVerzekerden"] ? OverigeVerzekerdenModel.fromJS(_data["overigeVerzekerden"]) : <any>null;
            this.wettelijkPensioenOfUitkering = _data["wettelijkPensioenOfUitkering"] ? WettelijkPensioenOfUitkeringModel.fromJS(_data["wettelijkPensioenOfUitkering"]) : <any>null;
        }
    }

    static fromJS(data: any): VerdragsbijdrageInputModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerdragsbijdrageInputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alleenstaandeKorting"] = this.alleenstaandeKorting !== undefined ? this.alleenstaandeKorting : <any>null;
        data["geboorteDatumVerzekerde"] = this.geboorteDatumVerzekerde ? this.geboorteDatumVerzekerde.toISOString() : <any>null;
        data["ingangsDatum"] = this.ingangsDatum ? this.ingangsDatum.toISOString() : <any>null;
        data["nietVerdienendePartnerKorting"] = this.nietVerdienendePartnerKorting !== undefined ? this.nietVerdienendePartnerKorting : <any>null;
        data["ouderenKorting"] = this.ouderenKorting !== undefined ? this.ouderenKorting : <any>null;
        data["woonland"] = this.woonland !== undefined ? this.woonland : <any>null;
        data["overigInkomen"] = this.overigInkomen ? this.overigInkomen.toJSON() : <any>null;
        data["overigeVerzekerden"] = this.overigeVerzekerden ? this.overigeVerzekerden.toJSON() : <any>null;
        data["wettelijkPensioenOfUitkering"] = this.wettelijkPensioenOfUitkering ? this.wettelijkPensioenOfUitkering.toJSON() : <any>null;
        return data;
    }
}

export interface IVerdragsbijdrageInputModel {
    alleenstaandeKorting?: boolean;
    geboorteDatumVerzekerde?: Date;
    ingangsDatum?: Date;
    nietVerdienendePartnerKorting?: boolean;
    ouderenKorting?: boolean;
    woonland?: string | null;
    overigInkomen?: IOverigInkomenModel | null;
    overigeVerzekerden?: IOverigeVerzekerdenModel | null;
    wettelijkPensioenOfUitkering?: IWettelijkPensioenOfUitkeringModel | null;
}

export class VerdragsbijdrageOutputModel implements IVerdragsbijdrageOutputModel {
    totaalAwbz?: number;
    totaalNominaal?: number;
    totaalPremieExclWoonlandFactor?: number;
    totaalPremieInclWoonlandFactor?: number;
    totaalZvwLaag?: number;
    woonlandFactor?: number;

    constructor(data?: IVerdragsbijdrageOutputModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totaalAwbz = _data["totaalAwbz"] !== undefined ? _data["totaalAwbz"] : <any>null;
            this.totaalNominaal = _data["totaalNominaal"] !== undefined ? _data["totaalNominaal"] : <any>null;
            this.totaalPremieExclWoonlandFactor = _data["totaalPremieExclWoonlandFactor"] !== undefined ? _data["totaalPremieExclWoonlandFactor"] : <any>null;
            this.totaalPremieInclWoonlandFactor = _data["totaalPremieInclWoonlandFactor"] !== undefined ? _data["totaalPremieInclWoonlandFactor"] : <any>null;
            this.totaalZvwLaag = _data["totaalZvwLaag"] !== undefined ? _data["totaalZvwLaag"] : <any>null;
            this.woonlandFactor = _data["woonlandFactor"] !== undefined ? _data["woonlandFactor"] : <any>null;
        }
    }

    static fromJS(data: any): VerdragsbijdrageOutputModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerdragsbijdrageOutputModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totaalAwbz"] = this.totaalAwbz !== undefined ? this.totaalAwbz : <any>null;
        data["totaalNominaal"] = this.totaalNominaal !== undefined ? this.totaalNominaal : <any>null;
        data["totaalPremieExclWoonlandFactor"] = this.totaalPremieExclWoonlandFactor !== undefined ? this.totaalPremieExclWoonlandFactor : <any>null;
        data["totaalPremieInclWoonlandFactor"] = this.totaalPremieInclWoonlandFactor !== undefined ? this.totaalPremieInclWoonlandFactor : <any>null;
        data["totaalZvwLaag"] = this.totaalZvwLaag !== undefined ? this.totaalZvwLaag : <any>null;
        data["woonlandFactor"] = this.woonlandFactor !== undefined ? this.woonlandFactor : <any>null;
        return data;
    }
}

export interface IVerdragsbijdrageOutputModel {
    totaalAwbz?: number;
    totaalNominaal?: number;
    totaalPremieExclWoonlandFactor?: number;
    totaalPremieInclWoonlandFactor?: number;
    totaalZvwLaag?: number;
    woonlandFactor?: number;
}

export class WettelijkPensioenOfUitkeringModel implements IWettelijkPensioenOfUitkeringModel {
    ingangsDatum?: Date | null;
    type?: string | null;
    bedrag?: number;

    constructor(data?: IWettelijkPensioenOfUitkeringModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ingangsDatum = _data["ingangsDatum"] ? new Date(_data["ingangsDatum"].toString()) : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.bedrag = _data["bedrag"] !== undefined ? _data["bedrag"] : <any>null;
        }
    }

    static fromJS(data: any): WettelijkPensioenOfUitkeringModel {
        data = typeof data === 'object' ? data : {};
        let result = new WettelijkPensioenOfUitkeringModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ingangsDatum"] = this.ingangsDatum ? this.ingangsDatum.toISOString() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["bedrag"] = this.bedrag !== undefined ? this.bedrag : <any>null;
        return data;
    }
}

export interface IWettelijkPensioenOfUitkeringModel {
    ingangsDatum?: Date | null;
    type?: string | null;
    bedrag?: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ClientApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isClientApiException = true;

    static isClientApiException(obj: any): obj is ClientApiException {
        return obj.isClientApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ClientApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}